import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { RescheduleModal } from './RescheduleModal';
import type { Booking, OnRescheduleCloseOptions } from './types';

const queryClient = new QueryClient({});

export const GuestReschedule = ({
  availableDates,
  booking,
  isOpen,
  onClose,
  isoTime = false,
  rescheduleStepRef,
}: {
  availableDates: Date[];
  booking: Booking;
  isOpen: boolean;
  isoTime: boolean;
  onClose: (options?: OnRescheduleCloseOptions) => void;
  rescheduleStepRef?: import('./types').RescheduleStepRef;
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <RescheduleModal
        availableDates={availableDates}
        booking={booking}
        isOpen={isOpen}
        isoTime={isoTime}
        onClose={onClose}
        rescheduleStepRef={rescheduleStepRef}
      />
    </QueryClientProvider>
  );
};
